/* eslint-disable */
export default {
  ringing: 'Appel entrant',
  callConnected: 'Appel connecté',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
